import _ from "lodash"


import {
  STATE_KEY
} from "@/subjects/constant";
export default {
  namespaced: true,
  state: {
    user: undefined,
    token:""
  },
  getters: {
    user: state => {
      if (!state.user) {
        try {
          const user = localStorage.getItem(STATE_KEY.APP_USER_KEY)
          state.user = JSON.parse(user)
        } catch (e) {
          console.error(e)
        }
      }
      return state.user
    },
    token: state => {
      
      if (!state.token) {
        try {
          const token = localStorage.getItem(STATE_KEY.APP_TOKEN_KEY)
          state.token = token
        } catch (e) {
          console.error(e)
        }
      }
      return state.token
    },
    
  },
  mutations: {
    setUser (state, user) {
      state.user = user
      console.log(user,STATE_KEY.APP_USER_KEY)
      localStorage.setItem(STATE_KEY.APP_USER_KEY, JSON.stringify(user))
    },
    setToken (state, token) {
      state.token = token
      if(token){
        localStorage.setItem(STATE_KEY.APP_TOKEN_KEY, token)
      }else{
        localStorage.removeItem(STATE_KEY.APP_TOKEN_KEY)
        localStorage.removeItem(STATE_KEY.APP_USER_KEY)
      }
      
      
    },

  },
 
}
